module.exports = __webpack_public_path__ + "img/selectedRB.aaa2963c.png";